function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 253.688,
  cy: 371.25,
  r: 92.25,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 24
}), /*#__PURE__*/React.createElement("circle", {
  cx: 425.813,
  cy: 423.563,
  r: 35.438,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 24
}), /*#__PURE__*/React.createElement("circle", {
  cx: 81.563,
  cy: 423.563,
  r: 35.438,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 24
}), /*#__PURE__*/React.createElement("circle", {
  cx: 351.563,
  cy: 536.063,
  r: 50.063,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 24
}), /*#__PURE__*/React.createElement("circle", {
  cx: 253.688,
  cy: 180.703,
  r: 46.828,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 24
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 24,
  d: "M126.959 409.765l26.964-8.194M319.865 482.688l-12.934-21.781M380.416 409.765l-26.964-8.194M253.688 239.531V267"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 253.688,
  cy: 371.25,
  r: 55.578,
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 24
}));

var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "34.125 121.875 439.125 476.25"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,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";
export { SvgLogo as ReactComponent };